export default __webpack_public_path__ + "static/media/more-violet.064c7521.svg";